module.exports = __webpack_public_path__ + "static/media/icon_cart_confirmation.d3c11dd3.svg";